<div class="breadcrumb-area" data-uiid="new-eff-breadcrumbs">
    <span class="section bold">
        <span [title]="'effBreadcrumbInfo.controlIdentifier' | t" data-uiid="new-eff-breadcrumbs-control-identifier">{{
            effectivenessModel.controlIdentifier
        }}</span>
        <span [title]="'effBreadcrumbInfo.controlName' | t" data-uiid="new-eff-breadcrumbs-control-name">{{
            effectivenessModel.controlName
        }}</span>
    </span>

    <span class="separator">|</span>

    <span class="section">
        <span [title]="'effBreadcrumbInfo.testPlanName' | t" data-uiid="new-eff-breadcrumbs-testplan-name">{{
            effectivenessModel.name
        }}</span>
        <span [title]="'effBreadcrumbInfo.startDate' | t" data-uiid="new-eff-breadcrumbs-testplan-start-date"
            >({{ effectivenessModel.startDate | dateFormat }}</span
        >
        <span class="mx-0">-</span>
        <span [title]="'effBreadcrumbInfo.endDate' | t" data-uiid="new-eff-breadcrumbs-testplan-end-date"
            >{{ effectivenessModel.endDate | dateFormat }})</span
        >
    </span>

    <span class="separator">|</span>

    <span class="section">
        <span [title]="'effBreadcrumbInfo.periodName' | t" data-uiid="new-eff-breadcrumbs-testplan-period-name">{{
            effectivenessModel.groupName
        }}</span>
    </span>
</div>
